import { Command } from 'commander';
import { clearAllTokens } from '../token-store.js';
import { currentAuthKind } from '../auth.js';
import { ApiClient } from '../client.js';

export const logoutCommand = new Command('logout')
  .description('Remove stored authentication credentials')
  .action(async () => {
    const kind = await currentAuthKind();

    // For OAuth sessions, ask the backend to revoke the WorkOS session so cross-device
    // logout works. Best-effort — errors don't block local credential cleanup.
    if (kind === 'oauth') {
      try {
        const client = new ApiClient();
        await client.request('POST', '/v1/auth/logout');
      } catch (err) {
        console.warn(`rekor: server-side logout failed (${err instanceof Error ? err.message : 'unknown'}); clearing local credentials anyway.`);
      }
    }

    await clearAllTokens();
    console.log('Logged out successfully');
  });
